import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/home/Home";
import OurTeam from "../pages/our-team/OurTeam";
import TeamDetails from "../pages/TeamDetails";
import CurrentStudies from "../pages/current-studies/CurrentStudies";
import ScrollToTop from "./ScrollToTop";
import ContactUs from "../pages/contact-us/ContactUs";
import OurValues from "../pages/our-values/OurValues";
import NotFoundPage from "../pages/not-found/NotFoundPage";
import StudiesDetails from "../pages/studies-details/StudiesDetails";

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/current-studies" element={<CurrentStudies />} />
        <Route path="/current-studies/:id" element={<StudiesDetails />} />

        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/our-values" element={<OurValues />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/our-team/:id" element={<TeamDetails />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
